import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

export type DeleteEntityTypeParameters = {
  id: EntityTypeId
}

const deleteEntityType = async ({ id }: DeleteEntityTypeParameters): Promise<void> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`,
    {
      method: 'DELETE',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from deleteEntityType endpoint`)
  })
}

export default deleteEntityType
